import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import {
  Box,
  Typography,
  Grid,
  Button,
  Container,
  // Tabs,
  // Tab,
  // TextField,
  Snackbar,
  Alert,
  // Avatar,
  Backdrop,
  CircularProgress,
  Link,
} from "@mui/material";
import Swal from "sweetalert2";
import SuiBox from "components/SuiBox";
import InputPassword from "components/InputPasswordCustome";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Pagination from "@mui/material/Pagination";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorIcon from "@mui/icons-material/Error";
import AOS from "aos";
import "aos/dist/aos.css";
import { changePassword } from "api/UserAPI";
import DownloadIcon from "@mui/icons-material/Download";
import {
  search,
  deleteDesign,
  downloadImageUrl,
  downloadZipDesigns,
} from "api/CustomerDesignService";
import DashboardNavbarCustom from "examples/Navbars/DashboardNavbarCustom";
import FooterCustom from "components/FooterCustom/FooterCustom";
import DesignItem from "./Design/DesignItem";
import CreateRequest from "./Design/CreateRequest";

// Component TabPanel với propTypes có .isRequired
function TabPanel({ children, value, index }) {
  return value === index ? <Box sx={{ p: 2 }}>{children}</Box> : null;
}

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

function Profile() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user) {
    window.location.href = "/";
  }
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  const [isAddOpen, setIsAddOpen] = useState(false);

  const [tabIndex, setTabIndex] = useState(0);
  // const [accountInfo, setAccountInfo] = useState({
  //   fullName: "",
  //   email: "",
  //   phone: "",
  // });
  const [designs, setDesigns] = useState([]);
  const [page, setPage] = useState(0);
  const [size] = useState(5);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const fetchData = async (pageToLoad = page) => {
    setDesigns([]);
    const res = await search({ page: pageToLoad, size });
    if (res?.object) {
      setDesigns(res.object.datas);
      setTotalPages(Math.ceil(res.object.totals / size));
      setTotalItems(res.object.totals);
    }
  };
  useEffect(() => {
    fetchData(); // dùng page hiện tại
  }, [page]);

  const refreshDataAfterChange = async () => {
    const res = await search({ page, size });
    if (res?.object) {
      setDesigns(res.object.datas);
      setTotalPages(Math.ceil(res.object.totals / size));
      setTotalItems(res.object.totals);
    }
  };

  const [showSnackBar, setShowSnackBar] = useState(false);

  const [checkedIds, setCheckedIds] = useState([]);
  const handleEdit = (id) => {
    // eslint-disable-next-line no-console
    console.log(id);
  };
  const [responseData, setResponseData] = useState({
    status: "",
    message: "",
  });
  const handleDownloadImage = async () => {
    if (checkedIds.length === 0) {
      setShowSnackBar(true);
      setResponseData({ status: 201, message: "Vui lòng chọn thiết kế" });
      return;
    }

    if (checkedIds.length === 1) {
      const id = checkedIds[0];
      const item = designs.find((i) => i.id === id);
      const { objectUrl, filename, error } = await downloadImageUrl(item.encryptedId, id);

      if (objectUrl) {
        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = filename; // ✅ dùng tên từ backend
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);
      } else {
        setShowSnackBar(true);
        setResponseData({ status: 201, message: error });
        return;
      }

      setShowSnackBar(true);
      setResponseData({ status: 200, message: "Tải ảnh thành công!" });
      return;
    }
    const { objectUrl, filename, error } = await downloadZipDesigns(checkedIds);

    if (objectUrl) {
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
      setShowSnackBar(true);
      setResponseData({ status: 200, message: "Tải file ZIP thành công!" });
    } else {
      Swal.fire("Lỗi", error || "Không thể tải file", "error");
    }
  };

  const [requestData, setRequestData] = useState();
  const handleOrder = (request) => {
    setIsAddOpen(true);
    setRequestData(request);
  };
  const handleDelete = (id) => {
    Swal.fire({
      title: "Bạn có chắc muốn xóa thiết kế này?",
      text: "Hành động này không thể hoàn tác!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Xóa",
      cancelButtonText: "Hủy",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await deleteDesign(id);
        if (res?.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Đã xóa thành công!",
            showConfirmButton: false,
            timer: 1500,
          });
          // Làm mới dữ liệu
          const reloadPage = page > 0 && designs.length === 1 ? page - 1 : page;
          setPage(reloadPage);
          refreshDataAfterChange();
        } else {
          Swal.fire({
            icon: "error",
            title: "Xóa thất bại",
            text: res?.message || "Đã có lỗi xảy ra",
          });
        }
      }
    });
  };

  const handleCheck = (id) => {
    setCheckedIds((prev) => (prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]));
    // eslint-disable-next-line no-console
    console.log(checkedIds);
  };

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handlePageChange = (event, newPage) => {
    const nextPage = newPage - 1;

    const reloadPage = nextPage > 0 && designs.length === 1 ? nextPage - 1 : nextPage;
    setPage(reloadPage); // sẽ kích hoạt useEffect => fetchData(reloadPage)
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Bạn có chắc muốn đăng xuất?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Đăng xuất",
      cancelButtonText: "Hủy",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("refreshToken");
        window.location.href = "/authentication/sign-in";
      }
    });
  };

  // const handleChangeAccount = (e) => {
  //   const { name, value } = e.target;
  //   setAccountInfo((prev) => ({ ...prev, [name]: value }));
  // };

  // const handleSubmitAccount = (e) => {
  //   e.preventDefault();
  //   console.log("Thông tin cập nhật:", accountInfo);
  //   // TODO: gọi API cập nhật nếu cần
  // };
  const [password, setPassword] = useState({
    password: "",
    showPassword: false,
  });
  const [passwordNew, setPasswordNew] = useState({
    passwordNew: "",
    showPassword: true,
  });
  const [rePasswordNew, setRePasswordNew] = useState({
    passwordNew: "",
    showPassword: true,
  });
  const validateForm = () => {
    if (!password.password || password.password.trim() === "") {
      setResponseData({ message: "Mật khẩu không được để trống" });
      return false;
    }
    if (!passwordNew.password || passwordNew.password.trim() === "") {
      setResponseData({ message: "Mật khẩu không được để trống" });
      return false;
    }
    if (!rePasswordNew.password || rePasswordNew.password.trim() === "") {
      setResponseData({ message: "Mật khẩu không được để trống" });
      return false;
    }
    if (passwordNew?.password?.length > 50) {
      setResponseData({ message: "Mật khẩu không được quá 50 ký tự" });
      return false;
    }
    if (!rePasswordNew.password || rePasswordNew.password.trim() === "") {
      setResponseData({ message: "Xác nhận mật khẩu không được để trống" });
      return false;
    }
    const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (!strongPasswordRegex.test(passwordNew.password)) {
      setResponseData({
        message:
          "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt",
      });
      return false;
    }
    if (passwordNew.password !== rePasswordNew.password) {
      setResponseData({ message: "Mật khẩu xác nhận không khớp" });
      return false;
    }
    setResponseData({ message: "" }); // clear message nếu hợp lệ
    return true;
  };
  const [isLoading, setIsLoading] = useState(false);

  const onChangePassword = async () => {
    if (!validateForm()) return;
    const finalData = {
      username: user.email,
      oldPassword: password.password,
      password: passwordNew.password,
    };
    setIsLoading(true);
    changePassword(finalData).then((data) => {
      if (data) {
        if (data.status === 200) {
          setIsLoading(false);
          setPassword("");
          setPasswordNew("");
          setRePasswordNew("");

          Swal.fire({
            title: data.message,
            icon: "success",
            showConfirmButton: false,
            timer: 2000, // hoặc 3000 nếu muốn
          }).then(() => {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("refreshToken");
            setTimeout(() => {
              navigate("/authentication/sign-in");
            }, 0); // hoặc 0 nếu muốn đi ngay khi Swal đóng
          });
        } else {
          setIsLoading(false);
          Swal.fire({
            title: data.message,
            icon: "error",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } else {
        setIsLoading(false);
        setResponseData({
          message: "Có lỗi xảy ra trong hệ thống",
          status: 201,
        });
      }
    });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f8f9fa",
      }}
    >
      <DashboardNavbarCustom page="Trang chủ" />
      <Box sx={{ flexGrow: 1, minHeight: "800px" }}>
        <Box sx={{ backgroundColor: "white", py: 6 }}>
          <Container maxWidth="lg">
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Box sx={{ px: { xs: 2, md: 4 }, pt: 3 }}>
                  <Breadcrumbs aria-label="breadcrumb">
                    {/* Trang chủ */}
                    <Typography
                      color="text.secondary"
                      role="button"
                      tabIndex={0}
                      onClick={() => navigate("/")}
                      sx={{
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 400,
                        "&:hover": {
                          color: "text.primary",
                          fontWeight: 500,
                        },
                        "&:focus": {
                          outline: "none",
                          color: "text.primary",
                          fontWeight: 500,
                        },
                      }}
                    >
                      Trang chủ
                    </Typography>

                    {/* Tên tab hiện tại */}
                    <Typography
                      sx={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: "text.primary",
                      }}
                    >
                      {tabIndex === 0 && "Thiết kế của tôi"}
                      {tabIndex === 1 && "Thông tin tài khoản"}
                      {tabIndex === 2 && "Đổi mật khẩu"}
                    </Typography>
                  </Breadcrumbs>
                </Box>
              </Grid>
              {/* Tabs bên trái */}
              <Grid item xs={12} md={3}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    borderRight: "2px solid #0094FF",
                    pr: 2,
                  }}
                >
                  {[
                    { label: "Thiết kế của tôi", index: 0 },
                    { label: "Thông tin tài khoản", index: 1 },
                    { label: "Đổi mật khẩu", index: 2 },
                    { label: "Đăng xuất", index: 3, onClick: handleLogout },
                  ].map((item) => (
                    <Button
                      key={item.index}
                      variant="text"
                      onClick={() => {
                        if (item.onClick) {
                          item.onClick(); // ✅ không return
                        } else {
                          setTabIndex(item.index);
                        }
                      }}
                      sx={{
                        justifyContent: "flex-start",
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 500,
                        px: 2,
                        py: 1.5,
                        fontSize: 16,
                        color: tabIndex === item.index ? "#0094FF" : "#000",
                        backgroundColor: tabIndex === item.index ? "#E3F2FD" : "transparent",
                        borderLeft:
                          tabIndex === item.index ? "4px solid #0094FF" : "4px solid transparent",
                        "&:hover": {
                          backgroundColor: "#f0f0f0",
                        },
                      }}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
              </Grid>

              {/* Nội dung theo tab */}
              <Grid item xs={12} md={9}>
                <TabPanel value={tabIndex} index={0}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 2,
                    }}
                  >
                    <Grid container spacing={2} alignItems="center" mb={3}>
                      {/* Tiêu đề */}
                      <Grid item xs={12} mb={2}>
                        <Typography variant="h5" fontWeight="bold">
                          THIẾT KẾ CỦA TÔI
                        </Typography>
                      </Grid>

                      {/* Lưu ý và nút tải ảnh */}
                      <Grid item xs={12} md={9}>
                        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                          Lưu ý:
                        </Typography>
                        <ul style={{ paddingLeft: "1.2rem", marginTop: 4, marginBottom: 0 }}>
                          <li>
                            <Typography variant="body2">
                              Thiết kế chỉ mang tính chất tham khảo
                            </Typography>
                          </li>
                          <li>
                            <Typography variant="body2">
                              Nếu bạn cần mẫu thiết kế vui lòng{" "}
                              <Link
                                href="http://zalo.me/0932087770"
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="none"
                                sx={{
                                  fontWeight: 500,
                                  color: "inherit",
                                  transition: "all 0.2s ease",
                                  "&:hover": {
                                    textDecoration: "underline",
                                    fontWeight: "bold",
                                  },
                                }}
                              >
                                liên hệ đồng phục Zumi
                              </Link>{" "}
                              để được hỗ trợ
                            </Typography>
                          </li>
                        </ul>
                      </Grid>

                      <Grid item xs={12} md={3} sx={{ textAlign: { xs: "left", md: "right" } }}>
                        <Button
                          variant="contained"
                          startIcon={<DownloadIcon />}
                          component="label"
                          onClick={handleDownloadImage}
                          sx={{ whiteSpace: "nowrap" }}
                        >
                          Tải ảnh
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box display="flex" flexDirection="column" gap={2}>
                    {designs?.map((item) => (
                      <Box
                        key={item.id}
                        data-aos="fade-up"
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: 2,
                          p: 2,
                          borderRadius: 2,
                          background: "rgba(255, 255, 255, 0.85)",
                          backdropFilter: "blur(6px)",
                          boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            transform: "translateY(-3px)",
                            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                          },
                        }}
                      >
                        {/* Nội dung và nút */}
                        <Box flex={1}>
                          <Typography variant="h6" fontWeight="bold" gutterBottom>
                            {item.name}
                          </Typography>
                          {/* <Typography variant="body2" color="text.secondary" mb={1}>
                            {item.description || "Không có mô tả"}
                          </Typography> */}

                          <DesignItem
                            item={item}
                            checked={checkedIds.includes(item.id)}
                            onCheck={() => handleCheck(item.id)}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                            onOrder={handleOrder}
                          />
                        </Box>
                      </Box>
                    ))}
                  </Box>

                  <Box display="flex" justifyContent="center" mt={10}>
                    <Pagination
                      count={totalPages}
                      page={page + 1}
                      onChange={handlePageChange}
                      color="primary"
                    />
                    <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                      Tổng cộng: {totalItems} thiết kế
                    </Typography>
                  </Box>
                </TabPanel>
                <TabPanel value={tabIndex} index={1}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} mb={2}>
                      <Typography variant="h5" fontWeight="bold">
                        THÔNG TIN CÁ NHÂN
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography>
                        <Box component="span" fontWeight="bold">
                          Họ và tên:
                        </Box>{" "}
                        {user?.fullName || "--"}
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography>
                        <Box component="span" fontWeight="bold">
                          Email:
                        </Box>{" "}
                        {user?.email || "--"}
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography>
                        <Box component="span" fontWeight="bold">
                          Số điện thoại:
                        </Box>{" "}
                        {user?.phone || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value={tabIndex} index={2}>
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      maxWidth: "400px",
                    }}
                  >
                    <Grid item xs={12} mb={2}>
                      <Typography variant="h5" fontWeight="bold">
                        ĐỔI MẬT KHẨU
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <SuiBox mb={2}>
                        <SuiTypography
                          sx={{
                            fontSize: "16px",
                            color: "var(--gray-100)",
                            fontWeight: "600",
                            textTransform: "none",
                          }}
                        >
                          Mật khẩu hiện tại
                        </SuiTypography>
                        <InputPassword
                          placeholder="Nhập mật khẩu hiện tại"
                          value={password}
                          onChange={setPassword}
                          error={responseData.message === "Mật khẩu không được để trống"}
                          helperText={
                            responseData.message === "Mật khẩu không được để trống"
                              ? responseData.message
                              : ""
                          }
                        />
                      </SuiBox>
                    </Grid>
                    <Grid item xs={12}>
                      <SuiBox mb={2}>
                        <SuiTypography
                          sx={{
                            fontSize: "16px",
                            color: "var(--gray-100)",
                            fontWeight: "600",
                            textTransform: "none",
                          }}
                        >
                          Mật khẩu mới
                        </SuiTypography>
                        <InputPassword
                          placeholder="Tạo mật khẩu mới"
                          value={passwordNew}
                          onChange={setPasswordNew}
                          error={
                            responseData.message === "Mật khẩu không được để trống" ||
                            responseData.message === "Mật khẩu phải có ít nhất 6 ký tự" ||
                            responseData.message ===
                              "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt" ||
                            responseData.message === "Mật khẩu không được quá 50 ký tự"
                          }
                          helperText={
                            responseData.message === "Mật khẩu không được để trống"
                              ? "Mật khẩu không được để trống"
                              : responseData.message === "Mật khẩu phải có ít nhất 6 ký tự"
                              ? "Mật khẩu phải có ít nhất 6 ký tự"
                              : responseData.message ===
                                "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt"
                              ? "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt"
                              : responseData.message === "Mật khẩu không được quá 50 ký tự"
                              ? responseData.message
                              : ""
                          }
                        />
                      </SuiBox>
                    </Grid>
                    <Grid item xs={12}>
                      <SuiBox mb={2}>
                        <SuiTypography
                          sx={{
                            fontSize: "16px",
                            color: "var(--gray-100)",
                            fontWeight: "600",
                            textTransform: "none",
                          }}
                        >
                          Xác nhận mật khẩu
                        </SuiTypography>
                        <InputPassword
                          placeholder="Xác nhận lại mật khẩu mới"
                          value={rePasswordNew}
                          onChange={setRePasswordNew}
                          error={
                            responseData.message === "Xác nhận mật khẩu không được để trống" ||
                            responseData.message === "Mật khẩu xác nhận không khớp"
                          }
                          helperText={
                            responseData.message === "Xác nhận mật khẩu không được để trống"
                              ? "Xác nhận mật khẩu không được để trống"
                              : responseData.message === "Mật khẩu xác nhận không khớp"
                              ? "Mật khẩu xác nhận không khớp"
                              : ""
                          }
                        />
                      </SuiBox>
                    </Grid>
                    <Grid item xs={12}>
                      <SuiBox mb={2} textAlign="center">
                        <SuiButton
                          size="small"
                          color="var(--blue-blue-100)"
                          circular
                          sx={{
                            width: "100% !important",
                            background: "var(--blue-blue-100)",
                            borderRadius: "15px",
                            padding: "8px 24px",
                          }}
                          onClick={onChangePassword}
                        >
                          <Typography
                            whiteSpace="nowrap"
                            variant="body2"
                            color="white"
                            fontSize="18px"
                          >
                            Đổi mật khẩu
                          </Typography>
                        </SuiButton>
                      </SuiBox>
                    </Grid>
                  </Grid>
                </TabPanel>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={showSnackBar}
        autoHideDuration={1500}
        onClose={() => setShowSnackBar(false)}
      >
        <Alert
          onClose={() => setShowSnackBar(false)}
          variant="filled"
          // sx={{ backgroundColor: responseData.status === 200 ? "#39ac39" : "#f44336" }}
          icon={
            responseData.status === 200 ? (
              <CheckCircleOutlineIcon style={{ color: "white" }} />
            ) : (
              <ErrorIcon style={{ color: "white" }} />
            )
          }
          severity={responseData.status === 200 ? "success" : "error"}
        >
          <Typography color="white" variant="body2">
            {responseData.message}
          </Typography>
        </Alert>
      </Snackbar>
      <CreateRequest
        open={isAddOpen}
        onClose={() => setIsAddOpen(false)}
        initialData={requestData}
        refreshDataAfterChange={refreshDataAfterChange}
      />
      <FooterCustom />

      {/* Nút scroll lên đầu */}
      <Button
        onClick={handleScrollTop}
        variant="contained"
        color="primary"
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          zIndex: 999,
          width: "36px !important",
          height: "36px !important",
          minWidth: "unset",
          minHeight: "unset",
          padding: 0,
          borderRadius: "50%",
          boxShadow: 3,
          "&:hover": {
            backgroundColor: "primary.dark",
          },
        }}
      >
        <KeyboardArrowUpIcon />
      </Button>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}

export default Profile;
